import { createReducer } from '@reduxjs/toolkit'
import { Language } from 'interfaces/api/languages.interfaces'
import { createBuilder } from 'packages/redux-toolkit'

import { getLanguages } from './actions'

interface LanguagesState {
  list: {
    loading: boolean
    items: Language[]
  }
}

const initialState: LanguagesState = {
  list: {
    loading: false,
    items: [],
  },
}

export const languagesReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getLanguages.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getLanguages.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getLanguages.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })
})
